// @ts-nocheck
import React, { useCallback, useState } from 'react';
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';
import { isValueEmpty } from '../../utils/Utils';

export default function useTemplate() {
  const [entityList, setEntityList] = useState([]);
  const [sectionData, setSectionData] = React.useState();
  const customEntityList = useCallback((body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_TEMPLATE_LIST}`,
        { params: body, loader }
      )
      .then((res) => {
        if (res?.data) {
          setEntityList(isValueEmpty(res.data) ? [] : res.data);
        }
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  /**
   * This API will fetch the template details
   *
   * IF version_id not provided then it will return details of default version
   * @param {string} template_id - uuid of the template.
   * @param {string} version_id -  uuid of version .
   */
  const getSingleEntity = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_SINGLE_ENTITY}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createCustomEntity = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CREATE_ENTITY}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const updateCustomEntity = (body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CREATE_ENTITY}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  /**
   * This API will fetch the template attributes
   *
   * @param {string} template_id - uuid of the template.
   * @param {string} version_id -  uuid of version.
   *
   * OR
   *
   * @param {string} entity_id - uuid of the entity.
   * @param {string} entity_type - type of the entity.
   */
  const getCustomEntityTemplate = useCallback((body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_ATTRIBUTES}`,
        { params: body, loader }
      )
      .then((res) => {
        setSectionData(res.data);
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getSummarySectionsAttributeOrder = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_SUMMARY_SECTIONS_ATTRIBUTES_ORDER}`,
        { params: body }
      )
      .then((res) => {
        setSectionData(res.data);
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  /**
   * This API will delete the template
   * @param {string} template_id - uuid of the template.
   */
  const deleteTemplate = (body) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.DELETE_TEMPLATE}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const reorderTemplate = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.REORDER_TEMPLATE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  /**
   * This API will check if we have any entity created with this template
   * @param {string} template_id - uuid of the template.
   */
  const checkTemplateForAffectedEntities = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CHECK_TEMPLATE}`,
        {
          params,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getTemplateHealthDefinitions = (params) =>
    axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.HEALTH_DEFINITIONS}`,
      {
        params,
      }
    );

  const updateTemplateHealthDefinition = (body, params) =>
    axios.put(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.HEALTH_DEFINITIONS}`,
      body,
      {
        params,
      }
    );

  const orderSummarySectionsAttribute = (body) =>
    axios.post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.ORDER_SUMMARY_SECTIONS_ATTRIBUTES_ORDER}`,
      body
    );

  const deleteTemplateHealthDefinition = (params) =>
    axios.delete(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.HEALTH_DEFINITIONS}`,
      {
        params,
      }
    );

  const createTemplateHealthDefinition = (body, params) =>
    axios.post(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.HEALTH_DEFINITIONS}`,
      body,
      {
        params,
      }
    );

  const getTemplateFormulaPlaceholders = (params) =>
    axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.FORMULA_PLACEHOLDERS}`,
      {
        params,
      }
    );

  const updateTemplateSettings = (body, params) =>
    axios.put(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.SETTINGS}`,
      body,
      {
        params,
      }
    );

  /**
   * This API will fetch the common attributes between template versions
   *
   * @param {string} template_id - uuid of the template.
   * @param {array} template_version_ids -  uuid of versions.
   */
  const getVersionsCommonAttributes = useCallback(
    (body, params) =>
      axios.post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_VERSIONS_COMMON_ATTRIBUTES}`,
        body,
        {
          params,
        }
      ),
    []
  );

  const getChangeRequestVisibility = useCallback(
    (params) =>
      axios.get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CHANGE_REQUEST_ATTR_BLACKLIST}`,
        { params }
      ),
    []
  );

  const updateChangeRequestVisibility = useCallback(
    (body) =>
      axios.post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CHANGE_REQUEST_ATTR_BLACKLIST}`,
        body
      ),
    []
  );

  return {
    checkTemplateForAffectedEntities,
    reorderTemplate,
    deleteTemplate,
    getCustomEntityTemplate,
    getSingleEntity,
    customEntityList,
    createCustomEntity,
    updateCustomEntity,
    entityList,
    sectionData,
    setSectionData,
    setEntityList,
    createTemplateHealthDefinition,
    getTemplateHealthDefinitions,
    updateTemplateHealthDefinition,
    deleteTemplateHealthDefinition,
    getTemplateFormulaPlaceholders,
    updateTemplateSettings,
    getSummarySectionsAttributeOrder,
    orderSummarySectionsAttribute,
    getVersionsCommonAttributes,
    getChangeRequestVisibility,
    updateChangeRequestVisibility,
  };
}
